import Vuex from 'vuex'
import Vue from "vue";
import api from './../api/index'
import ContentDE from '../content-de.json';
import ContentFR from '../content-fr.json';

Vue.use(Vuex);
const MODAL_DELAY = 2000;

export const store = new Vuex.Store({
    state: {
        contestCountry: null,
        contestType: null,
        contestantEmail: null,
        wheelActive: false,
        price: null,
        priceType: null,
        codeStatus: null,
        formParticipation: null,
        formParticipationState: null,
        animationFinished: false,
        apiDown: false,
        content: {
            leadText: "",
            mainPricesTitle: "",
            mainPrices: [],
            pricesTitle: "",
            prices: [],
            content: null,
            itemsBig: null,
            products: [],
            errors: null,
            codeInputText: "",
            formLabels: null,
            languageLabel: ""
        },
        overlayOpen: false,
        formSubmitted: false,
        language: null,
        overlayContent: null,
        animationStartet: false,
        rotateStyle: {
            transform: '',
            transition: ''
        },
        code: null,
        contentPerLanguage: {
            'de': ContentDE,
            'fr': ContentFR,
        },
        defaultLanguage: 'de'
    },
    actions: {
        checkCode ({commit}, code) {
            api.checkCode(code).then(response => {
                if(response.type === 'valid') {
                    commit('CHANGE_WHEEL_STATE', true)
                    commit('CHANGE_CODE_STATE', 'valid')
                    commit('CHANGE_PRICE_STATE', response.price)
                    commit('CHANGE_PRICE_TYPE', 'default')
                    commit('SET_VALID_CODE', code)
                } else if(response.type === 'used') {
                    commit('CHANGE_CODE_STATE', 'used')
                } else if(response.type === 'invalid') {
                    commit('CHANGE_CODE_STATE', 'invalid')
                }
            }).catch(() =>  {
                // eslint-disable-next-line
                commit('CHANGE_API_DOWN', true)
                commit('CHANGE_CODE_STATE', 'error')
            })
        },
        resetCode({commit}) {
            commit('RESET_CODE', 'error')
        },
        checkFormParticipation({commit}, {data, onSuccess, onError}) {

            api.checkFormParticipation(data).then(response => {

                if(response.type === 'valid') {
                    commit('CHANGE_WHEEL_STATE', true)
                    commit('CHANGE_FORM_PARTICIPATION_STATE', response.price_type)
                    commit('CHANGE_PRICE_STATE', response.price)
                    commit('CHANGE_PRICE_TYPE', response.price_type)
                    commit('SET_VALID_FORM_PARTICIPATION', data)
                    commit('SET_CONTESTANT_EMAIL', data.email)

                    if (onSuccess) {
                        onSuccess();
                    }
                } else if(response.type === 'used') {
                    commit('CHANGE_FORM_PARTICIPATION_STATE', 'used')
                    if (onError) {
                        onError();
                    }
                } else if(response.type === 'invalid') {
                    commit('CHANGE_FORM_PARTICIPATION_STATE', 'invalid')
                    if (onError) {
                        onError();
                    }
                }
            }).catch(() =>  {
                // eslint-disable-next-line
                commit('CHANGE_API_DOWN', true)
                commit('CHANGE_FORM_PARTICIPATION_STATE', 'error')
                if (onError) {
                    onError();
                }
            })
        },
        resetFormParticipation({commit}) {
            commit('RESET_FORM_PARTICIPATION', 'error')
        },
        resetAll({commit}) {
            document.body.classList.remove('no-scroll');
            commit('RESET_ALL')
        },
        async runWheelAnimation({commit}, duration) {
            commit('START_ANIMATION', duration)

            await Vue.prototype.$recaptchaLoaded();
            const token = await Vue.prototype.$recaptcha('register');

            // submit form with email after wheel animation if no confirm is required for price type
            if (this.state.priceType === 'instant' || this.state.priceType === 'blank' ) {
                setTimeout(() => {
                    let data  = {}
                    data.email = this.state.contestantEmail
                    data['g-recaptcha-response'] = token
                    api.updateFormParticipation(data).then(() => {
                    }).catch(() =>  {
                        // eslint-disable-next-line
                    })
                },  8000)
            }
        },
        setContent({commit}, content) {
            commit('SET_CONTENT', content)
        },
        openOverlay({commit}, content) {
            history.pushState(content, 'overlay');
            commit('SET_OVERLAY_CONTENT', content)
            commit('OPEN_OVERLAY')
        },
        closeOverlay({commit}) {
            document.body.classList.remove('no-scroll');

            setTimeout(() => {
                commit('SET_OVERLAY_CONTENT', null)
                commit('CLOSE_OVERLAY')
            }, 0)

        },
        formSubmit({commit}) {
            commit('FORM_SUBMIT')
        },
        setLanguage({commit, dispatch, getters}, lang) {
            let hasLanguage = Object.keys(getters.contentPerLanguage).includes(lang);
            if (!hasLanguage) {
                lang = getters.defaultLanguage;
            }

            // set title and content
            let content = getters.contentPerLanguage[lang];
            document.title = content.title;
            dispatch('setContent', content);

            commit('SET_LANGUAGE', lang);
        },
        initLanguages({dispatch}) {
            // check navigator language
            let language = navigator.language.substring(0, 2);
            dispatch('setLanguage', language);
        },
        setContestantEmail({commit}, email) {
            commit('SET_CONTESTANT_EMAIL', email)
        }
    },
    mutations: {
        ['CHANGE_WHEEL_STATE'] (state, payload) {
            state.wheelActive = payload
        },
        ['CHANGE_PRICE_STATE'] (state, payload) {
            state.price = payload
        },
        ['CHANGE_PRICE_TYPE'] (state, payload) {
            state.priceType = payload
        },
        ['CHANGE_CODE_STATE'] (state, payload) {
            state.codeStatus = payload
        },
        ['RESET_CODE'] (state) {
            state.codeStatus = null
        },
        ['CHANGE_FORM_PARTICIPATION_STATE'] (state, payload) {
            state.formParticipationState = payload
        },
        ['RESET_FORM_PARTICIPATION'] (state) {
            state.formParticipation = null
        },
        ['START_ANIMATION'] (state, payload) {
            state.animationStartet = true;
            setTimeout(() => {
                state.rotateStyle.transition = `${payload.duration}s ease all`;
                state.rotateStyle.transform = `rotate(${payload.deg}deg)`;
                setTimeout(() => {
                    state.animationFinished = true;
                    history.pushState(null, '');
                    document.body.classList.add('no-scroll');

                }, payload.duration * 1000 + MODAL_DELAY)
            }, 200)
        },
        ['CHANGE_API_DOWN'] (state, payload) {
            state.apiDown = payload
        },
        ['SET_CONTENT'] (state, payload) {
            state.content = payload
        },
        ['RESET_ALL'] (state) {
            state.price = false;
            state.codeStatus = null;
            state.formParticipationState = null;
            state.animationFinished = false;
            state.apiDown = false;
            state.wheelActive = false;
            state.code = null;
            state.formSubmitted = false;
            state.animationStartet = false;
            state.rotateStyle = {
                transform: '',
                transition: ''
            };
        },
        ['SET_VALID_CODE'] (state, payload) {
            state.code = payload;
        },
        ['SET_VALID_FORM_PARTICIPATION'] (state, payload) {
            state.formParticipation = payload;
        },
        ['SET_OVERLAY_CONTENT'] (state, payload) {
            state.overlayContent = payload;
        },
        ['OPEN_OVERLAY'] (state) {
            state.overlayOpen = true
        },
        ['CLOSE_OVERLAY'] (state) {
            state.overlayOpen = false
        },
        ['FORM_SUBMIT'] (state) {
            state.formSubmitted = true
        },
        ['SET_LANGUAGE'] (state, payload) {
            state.language = payload
        },
        ['SET_CONTESTANT_EMAIL'] (state, payload) {
            state.contestantEmail = payload
        }
    },
    getters: {
        contestCountry: () => {
            return (process.env.VUE_APP_CONTEST_COUNTRY)  ? process.env.VUE_APP_CONTEST_COUNTRY : 'switzerland'
        },
        contestType: () => {
            return (process.env.VUE_APP_CONTEST_TYPE)  ? process.env.VUE_APP_CONTEST_TYPE : 'code'
        },
        wheelState: state => state.wheelActive,
        priceState: state => state.price,
        priceType: state => state.priceType,
        codeState: state => state.codeStatus,
        formParticipationState: state => state.formParticipationState,
        code: state => state.code,
        animationFinished: state => state.animationFinished,
        content: state => state.content,
        overlayOpen: state => state.overlayOpen,
        overlayContent: state => state.overlayContent,
        formSubmittedState: state => state.formSubmitted,
        language: state => state.language,
        rotateStyle: state => state.rotateStyle,
        animationStartet: state => state.animationStartet,
        defaultLanguage: state => state.defaultLanguage,
        contentPerLanguage: state => state.contentPerLanguage,
        contestantEmail: state => state.contestantEmail
    }
})